package gr.tech.site.styles.states

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.silk.style.CssStyle

val WashingtonHeroTextStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
    }
}
